export enum EBannerType {
  DealSale,
  MortgageBroker,
  SubsidisedMortgage,
  CianDobro,
}
